import { Component, Input } from '@angular/core';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'logo',
    template: `<!--component html goes here -->
<a class="navbar-brand">    
    <img src="celina-logo.png" width="115" /> <h3 class="float-right pt-2"><span class="divider pl-1">|</span> {{name}}</h3>
</a>
`,
    styles: [`h3{font-size:30px;font-weight:100}span.divider{color:#707070;font-weight:300}`]
})
export class LogoComponent {
    @Input() public name: string;
}
